
import { Button } from 'ant-design-vue';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import commonStore from '@/store/common';

export default defineComponent({
  components: {
    aButton: Button,
  },
  props: {},
  setup() {
    const router = useRouter();
    const goBack = () => {
      const { role, code } = commonStore.getState();
      if (!role || !code) {
        router.push('/');
      } else if (role === 'student') {
        router.push('/Student/home');
      } else if (['admin', 'teacher'].includes(role)) {
        router.push('/Teacher/home');
      } else {
        router.push('/');
      }
    };
    return {
      goBack,
    };
  },
});
